import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_REVENUE_ANALYSIS_FAILURE, FETCH_REVENUE_ANALYSIS_REQUEST, FETCH_REVENUE_ANALYSIS_SUCCESS } from "../actions/fetchRevenueAnalysisAction";

  const initialState = {
    bu_wise_revenue_analysis: [],
    bu_wise_revenue_analysis_loading: false,
    bu_wise_revenue_analysis_error: null,
  };
  
  const fetchRevenueAnalysisReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_REVENUE_ANALYSIS_REQUEST:
        return { ...state, bu_wise_revenue_analysis_loading: true , payload: action.payload};
      case FETCH_REVENUE_ANALYSIS_SUCCESS:
        return { ...state, bu_wise_revenue_analysis_loading: false, bu_wise_revenue_analysis: action.payload };
      case FETCH_REVENUE_ANALYSIS_FAILURE:
        return { ...state, bu_wise_revenue_analysis_loading: false, bu_wise_revenue_analysis_error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return { ...state, bu_wise_revenue_analysis_loading: false, bu_wise_revenue_analysis: [] };  
      default:
        return state;
    }
  };
  
  export default fetchRevenueAnalysisReducer;
  